<div fxLayout="column" fxLayoutGap="29px">
  <div fxLayout="row">
    <form fxFlex="20" [formGroup]="form" class="form">
      <div fxLayout="row" fxLayoutGap="8px" class="header">
        <span class="title">
          Projetos
        </span>
      </div>
      <div fxLayout="column">
        <p class="form-title">Filtros</p>
        <mat-form-field>
          <mat-label>Nome do Projeto</mat-label>
          <input matInput type="text" ngDefaultControl formControlName="campoAberto" id="campoAberto">
          <button matSuffix mat-icon-button aria-label="Clear">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>

        <p class="form-title">Localização</p>
        <mat-form-field>
          <mat-label>Estado</mat-label>
          <mat-select ngDefaultControl formControlName="estados" [ngModel]="estadoSelecionado"
            (selectionChange)="getRegionalList($event)" (selectionChange)="getTerritoryEstado($event)"
            (selectionChange)="getMunicipioEstado($event)">
            <mat-option>---</mat-option>
            @for (state of filterContent.stateList; track state) {
              <mat-option [value]="state">{{state.descricao}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Regional</mat-label>
          <mat-select ngDefaultControl formControlName="regionais" (selectionChange)="getTerritoryList($event)">
            <mat-option>---</mat-option>
            @for (regional of filterContent.regionalList; track regional) {
              <mat-option [title]="regional.descricao" [value]="regional">
                {{regional.descricao}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Território</mat-label>
          <mat-select ngDefaultControl formControlName="territorios" (selectionChange)="getMunicipioList($event)">
            <mat-option>---</mat-option>
            @for (territory of filterContent.territoryList; track territory) {
              <mat-option [value]="territory">
                {{territory.descricao}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Município</mat-label>
          <mat-select ngDefaultControl formControlName="municipios">
            <mat-option>---</mat-option>
            @for (municipio of filterContent.municipioList; track municipio) {
              <mat-option [value]="municipio">
                {{municipio.descricao}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <p class="form-title">Características</p>
        <mat-form-field>
          <mat-label>Maturidade</mat-label>
          <mat-select ngDefaultControl formControlName="estagioMaturidade">
            <mat-option>---</mat-option>
            @for (maturidade of filterContent.estagioMaturidade; track maturidade) {
              <mat-option [value]="maturidade.estagio">
                {{maturidade.label}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Ano</mat-label>
          <input matInput type="text" ngDefaultControl formControlName="ano" id="ano" type="number"
            maxlength="200">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Setores prioritários</mat-label>
          <mat-select ngDefaultControl formControlName="segmentos">
            <mat-option>---</mat-option>
            @for (segmento of filterContent.segmentos; track segmento) {
              <mat-option [value]="segmento">
                {{segmento.descricao}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Vertentes</mat-label>
          <mat-select ngDefaultControl formControlName="vertentes" (selectionChange)="getSubvertentes($event)">
            <mat-option>---</mat-option>
            @for (vertente of filterContent.vertentes; track vertente) {
              <mat-option [value]="vertente">
                {{vertente.nome}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Integrantes da vertentes</mat-label>
          <mat-select ngDefaultControl formControlName="subvertentes">
            <mat-option>---</mat-option>
            @for (subvertente of filterContent.subvertentes; track subvertente) {
              <mat-option [value]="subvertente">
                {{subvertente.nome}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <p class="form-title" id="limpar-filtros" (click)="resetarForm()">Limpar filtro</p>
    </form>

    <div fxFlex="80" class="project-list">
      <div class="margin" fxLayout="column" fxLayoutGap="20px" id="project-list">

        @if (projects.length === 0 && !isLoading) {
          <div fxLayout="column" fxLayoutGap="56px" class="no-content txt-center"
            >
            <span class="no-content-desc">Nenhum registro encontrado</span>
          </div>
        }

        @if (projects.length > 0) {
          <div fxLayout="row wrap" fxLayoutGap="16px grid">
            @for (project of projects; track project) {
              <app-project-card-public fxFlex="33.33" [project]="project"
                (shouldUpdateListEmitter)="getProjects(filterForm, 1)">
              </app-project-card-public>
            }
          </div>
        }

        @if (isLoading) {
          <app-loading-spinner></app-loading-spinner>
        }

      </div>
    </div>
  </div>
</div>